import { useEffect, useState, useCallback } from "react";

export function useJornayaLeadId(onLeadIdReceived) {
  const [leadId, setLeadId] = useState(null);

  const handleLeadId = useCallback((leadId) => {
    if (leadId) {
      setLeadId(leadId);
      onLeadIdReceived?.(leadId); // Optional callback for the caller
    }
  }, [onLeadIdReceived]);

  useEffect(() => {
    // Ensure global callback is available
    window.setUniversalLeadId = (leadId) => {
      console.log("Universal Lead ID received:", leadId);
      handleLeadId(leadId);
    };

    // Check for existing token
    const existingToken =
      window._leadid_token || 
      document.getElementById("leadid_token")?.value;

    if (existingToken) {
      handleLeadId(existingToken);
      return;
    }

    let isMounted = true;
    let interval;

    // Create main Jornaya script
    const mainScript = document.createElement("script");
    mainScript.id = "LeadiDscript";
    mainScript.type = "text/javascript";
    document.head.appendChild(mainScript);

    // Create campaign script
    const campaignScript = document.createElement("script");
    campaignScript.id = "LeadiDscript_campaign";
    campaignScript.type = "text/javascript";
    campaignScript.async = true;
    campaignScript.src = 
      "https://create.lidstatic.com/campaign/95ad4e5b-7b36-f2b6-009f-1517f5f09ef4.js?snippet_version=2&callback=setUniversalLeadId";

    // Insert campaign script before main script
    mainScript.parentNode.insertBefore(campaignScript, mainScript);

    // Polling as a backup
    interval = setInterval(() => {
      const token =
        window._leadid_token || 
        document.getElementById("leadid_token")?.value;

      if (token && isMounted) {
        handleLeadId(token);
        clearInterval(interval);
      }
    }, 250);

    // Cleanup
    return () => {
      isMounted = false;
      clearInterval(interval);
      // Optional: remove scripts if needed
      window.setUniversalLeadId = null;
    };
  }, [handleLeadId]);

  return leadId;
}